// import { getFilesServiceRoot, getHeaders, getHeadersAO } from './endpoints';
// import { APIError, handleApiError2 } from '../apis';
// import { Models } from '../../amplify/data/resource';
// import { generateClient } from 'aws-amplify/data';

// const client = generateClient<Schema>();

const protocol = "https:"; //window.location.protocol;

// export type FileListing = {
//     name: string;
//     type: string;
//     size: number;
//     ts: string;
// }

export class FileObject {
    content; // Uint8Array 
    modified;
  
    constructor(file, modified) {
      this.content = file;
      this.modified = modified;
    }
}

let fileServiceRoot;
let codeworkAccessToken;

export function setFileServiceRoot(fsRoot) {
    fileServiceRoot = fsRoot;
}

export function setCodeworkAccessToken(token) {
    codeworkAccessToken = token;
}

// function getServiceHostname() {
//     return localStorage.getItem('codework_service_host');
// }

function getFilesServiceRoot() {
    return fileServiceRoot;
    // const host = getServiceHostname();
    // return host + "/cw/api/v24/files";
}

const getCodeworkAccessToken = () => {
    return codeworkAccessToken;
    // return localStorage.getItem('codework_access_token');
}

const getAuthHeader = () => {
  return {
    "Authorization": `Bearer ${getCodeworkAccessToken()}`
  };
}

const getHeaders = () => ({
  headers: { ...getAuthHeader(), 'Content-Type': 'application/json' },
});

const getHeadersAO = () => ({
  headers: { ...getAuthHeader(), },
})

// async function handleApiError2(response) {
//   console.log('handleApiError2', response);
// }
// const APIError = (error) => {
//   console.log('APIError', error);
// }

function nameSort(f1, f2) {
    const n1 = f1.name;
    const n2 = f2.name;
    if (n1 < n2) {
        return -1;
    }
    if (n1 > n2) {
        return 1;
    }
    return 0;
}

function postProcessFilesResponse(responseObj) {
    const dirs = responseObj.files ? responseObj.files.filter((file) => file.type === 'dir') : [];
    const files = responseObj.files ? responseObj.files.filter((file) => file.type === 'file') : [];
    dirs.sort(nameSort);
    files.sort(nameSort);
    return dirs.concat(files)
}
  
export async function listDir(path, receiveListing) {
    // console.log('listDir', UWS_API_PREFIX(), `"${path.substring(2)}"`);
    try {
        const requestUrl = protocol + "//" + getFilesServiceRoot() + '/' + path;
        // console.log('listDir', requestUrl);
        let headers = getHeadersAO();
        headers.headers['X-Tz-Offset'] = -(new Date()).getTimezoneOffset();
        const response = await fetch(requestUrl, {
            method: 'GET',
            ...headers,
        });
        if (response.ok) {
            const responseObj = await response.json();
            receiveListing(postProcessFilesResponse(responseObj));
        } else {
            // const error = await handleApiError2(response);
            // APIError(error);
            throw new Error(`Error listing directory: ${path} ${response.status} ${response.statusText}`);
        }
    } catch (error) {
        throw error; //APIError(error);
    }
}

function base64ToUint8Array(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}

async function uint8ArrayToBase64(uint8Array) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => {
      // Extract the base64 part from the data URL
      const base64url = reader.result;
      const base64String = base64url.slice(base64url.indexOf(',') + 1);
      resolve(base64String);
    };
    reader.readAsDataURL(new Blob([uint8Array]));
  });
}

export async function getFile(path, callback) {
    try {
        let headers = getHeadersAO();
        headers.headers['X-Tz-Offset'] = -(new Date()).getTimezoneOffset();
        const response = await fetch(protocol + "//" + getFilesServiceRoot() + '/' + path, {
            method: 'GET',
            ...headers,
        });
        if (response.ok) {
            const responseObj = await response.json();
            const { contentEncoded, modified } = responseObj;
            const content = base64ToUint8Array(contentEncoded);
            const fileObj = new FileObject(content, modified);
            callback(path, fileObj);
        } else {
            throw new Error(`Error getting file: ${path} ${response.status} ${response.statusText}`);
        }
    } catch (error) {
        throw error; //APIError(error);
    }
}

export const userPath = (user) => {
    const [ username, domain ] = user.split('@');
    return domain + '/' + username + '/';
}

export async function newDir(name, path, receiveListing) {
    const name2 = name.trim();
    try {
        const response = await fetch(protocol + "//" + getFilesServiceRoot() + '/' + path, {
            method: 'POST',
            ...getHeaders(),
            body: JSON.stringify({name:name2, dir:true, content:'IGNORED'})
        });
        if (response.ok) {
            const responseObj = await response.json();
            receiveListing(postProcessFilesResponse(responseObj));
        } else {
            throw new Error(`Error creating directory: ${path} ${response.status} ${response.statusText}`);
        }
    } catch (error) {
        throw error; //APIError(error);
    }
}

export async function newFile(name, path, content, receiveListing) {
    try {
        const contentEncoded = await uint8ArrayToBase64(content);
        const response = await fetch(protocol + "//" + getFilesServiceRoot() + '/' + path, {
            method: 'POST',
            ...getHeaders(),
            body: JSON.stringify({name:name, dir:false, contentEncoded:contentEncoded})
        });
        if (response.ok) {
            const responseObj = await response.json();
            receiveListing ? receiveListing(postProcessFilesResponse(responseObj)) : null;
        } else {
            throw new Error(`Error creating file: ${path} ${response.status} ${response.statusText}`);
        }
    } catch (error) {
        throw error; //APIError(error);
    }
}

export async function updateFile(path, content) {
    try {
        const contentEncoded = await uint8ArrayToBase64(content);
        const response = await fetch(protocol + "//" + getFilesServiceRoot() + '/' + path, {
            method: 'PUT',
            ...getHeaders(),
            body: JSON.stringify({contentEncoded:contentEncoded})
        });
        if (!response.ok) {
            throw new Error(`Error updating file: ${path} ${response.status} ${response.statusText}`);
        }
    } catch (error) {
        throw error; //APIError(error);
    }
}
